// These functions are injected globally, so they do not need to be imported.

/**
 * i18n Webpack function
 */
export function __(msg: string): string {
    return msg;
}

/**
 * denotes a translation that isn't yet finalised, so shouldn't be pushed to translators.
 */
export function __placeholder(msg: string): string {
    return msg;
}
